import { useState } from 'react';
import { hasStorageAvailable } from '@klv/shared/utils/storage';

type TStorageSytems = 'sessionStorage' | 'localStorage';

const setStorageValue = (key: string, value: unknown, storageSystem: TStorageSytems) => {
  if (hasStorageAvailable(storageSystem)) {
    window[storageSystem].setItem(key, JSON.stringify(value));
  }
};

const getDefaultValue = (key: string, value: unknown, storageSystem: TStorageSytems) => {
  if (hasStorageAvailable(storageSystem)) {
    const storeItem = window[storageSystem].getItem(key);
    if (storeItem) {
      return JSON.parse(storeItem);
    }
    // we have storage available, but our key does not yet exist. Add it and set our default value.
    setStorageValue(key, value, storageSystem);
  }
  return value;
};

const useStorage = (key: string, value: unknown, storageSystem?: TStorageSytems) => {
  const store = storageSystem || 'localStorage';
  const [state, setState] = useState(getDefaultValue(key, value, store));
  const setStorageState = (v: unknown) => {
    setStorageValue(key, v, store);
    setState(v);
  };

  return [state, setStorageState];
};

export default useStorage;
